import { experiment } from "@faire/web--source/common/settings/declarations/experiment";

/**
 * Controls whether the brand reviews click to scroll feature is enabled on the PDP for logged in retailers on desktop.
 * PRD: https://www.notion.so/faire/Click-to-Scroll-to-Reviews-on-PDP-18a2efb5c25a8053aed6e27efe5c0191
 * XP Plan: https://www.notion.so/faire/XP-Plan-Click-to-Scroll-to-Reviews-18b2efb5c25a801c81f7d1cc97d13f82
 */
export const FE_BRAND_REVIEWS_CLICK_TO_SCROLL_PDP_DESKTOP_XP_250305 =
  experiment({
    name: "FE_BRAND_REVIEWS_CLICK_TO_SCROLL_PDP_DESKTOP_XP_250305",
    identifier: "RetailerTokenInSession",
    client: "RETAILER",
    notifyAfter: "2025-07-15",
    productArea: "BRAND_REVIEWS",
    defaultValue: false,
  });
